import {Company} from "../../../../models/Company";
import React from "react";
import CompanyReferralsTable from "../CompanyReferralsTable";

export default function NotesTab(props: { company: Company }) {

    const { company } = props;

    return (
        <>
            <CompanyReferralsTable company={company} />
        </>
    )
}
